// extracted by mini-css-extract-plugin
module.exports = {"discovery-unit":"discovery-units_discovery-unit__VrcOC"};